import gql from 'graphql-tag'

export default gql`query ($user_id: Int, $is_paid: Int){
  user_project_expenses(user_id: $user_id, is_paid: $is_paid){
      id
      user_id
      user{
        full_name
      }
      project{
        project_id
        name
      }
      expense_at
      destination
      description
      expense_type
      expense_type_obj{
        id
        description
      }
      net
      vat
      gross
      created_at
      paid_at
      file_path
  }
}`